import { LOCALES } from 'utils/languageUtils';

/** @type {Readonly<Record<LOCALES.ENGLISH | LOCALES.GREEK, Record<string, string>>>} */
const ROAMING_PRODUCTS_LABELS = Object.freeze({
  [LOCALES.ENGLISH]: {
    mainPlanTitle: 'Get your plan with you',
    plansTitles: 'Choose Extra Data & Voice Packages',
    showMore: 'More plans',
    showLess: 'Less plans',
    travelPass: {
      dataTitle: 'Available GB',
      voiceTitle: 'Available Minutes & SMS',
      planUsage: 'in your plan',
    },
    for: 'for',
    days: 'days',
    hours: 'hours',
    validity: {
      daily: 'per day',
      weekly: 'per week',
    },
  },
  [LOCALES.GREEK]: {
    mainPlanTitle: 'Πάρε το πρόγραμμα μαζί σου',
    plansTitles: 'Διάλεξε Έξτρα Πακέτα Data & Ομιλίας',
    showMore: 'Περισσότερα πακέτα',
    showLess: 'Λιγότερα πακέτα',
    travelPass: {
      dataTitle: 'Διαθέσιμα GB',
      voiceTitle: 'Διαθέσιμα Λεπτά & SMS',
      planUsage: 'του προγράμματός σου',
    },
    for: 'για',
    days: 'ημέρες',
    hours: 'ώρες',
    validity: {
      daily: 'ανά ημέρα',
      weekly: 'ανά εβδομάδα',
    },
  },
});
export default ROAMING_PRODUCTS_LABELS;
